// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__q73Ah","validationTips":"StatementDescriptor_validationTips__2zB3B"};